<template>
	<div class="processedDetail" v-if="listOrder">
		<div style="font-size: 18px;margin-bottom: 20px;" @click="hfkf">{{ $t('processed.RecordDetails') }}</div>

		<el-dialog :title="textDesc" :visible.sync="dialogVisible" width="50%">
			<el-table :data="tableData" border style="width: 100%">
				<el-table-column prop="logisticsRule.logisticsName" :label="$t('processed.Couriername')"></el-table-column>
				<el-table-column prop="logisticsRule.firstWeight" :label="$t('processed.firstheavy')"></el-table-column>
				<el-table-column prop="logisticsRule.firstFee" :label="$t('processed.heavycost')"></el-table-column>
				<el-table-column prop="logisticsRule.weightFee" :label="$t('processed.Continuedheavy')"></el-table-column>
				<el-table-column :label="$t('processed.chargemode')">
					<template slot-scope="scope">
						<span>{{ scope.row.type == 0 ? volumeweight : scope.row.type == 1 ? weight : Takeofboth }}</span>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="tableData.length > 0" style="margin-top:20px;font-size:18px;font-weight:500">
				<span style="margin-right:20px">{{ $t('processed.actualweight') }}:{{ tableData[0].weight }}kg</span>
				<span style="margin-right:20px">{{ $t('processed.actualvolume') }}:{{ tableData[0].length }} X
					{{ tableData[0].width }} X {{ tableData[0].height }} cm</span>
				<span style="margin-right:20px;color:red">{{ $t('processed.actualcharges') }}:{{ tableData[0].paidIntegral
				}}
					{{ $t('processed.integral') }}</span>
			</div>

			<div v-if="tableData.length > 0 && userPos == 'STORE'" style="margin-top:20px;font-size:18px;font-weight:500">
				<span style="margin-right:20px">{{ $t('processed.Actualexpressfee') }}:{{ tableData[0].actualCost }}</span>
				<span style="margin-right:20px">{{ $t('processed.currency') }}:{{ tableData[0].currency }}</span>

			</div>

			<div v-if="tableData.length > 0" style="margin-top:20px;font-size:18px;font-weight:500">
				<span style="margin-right:20px">{{ $t('processed.Actualexpressfee') }}:{{ tableData[0].actualCost }}</span>
				<span style="margin-right:20px">{{ $t('processed.currency') }}:{{ tableData[0].currency }}</span>


			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{ $t('processed.cancel') }}</el-button>
				<el-button type="primary" @click="dialogVisible = false">{{ $t('processed.confirm') }}</el-button>
			</span>
		</el-dialog>
		<div class="ppo" v-if="listOrder">
			<div class="ppo-item">{{ $t('processed.Dateofpackaging') }}：{{ shopInfo.packagedTime }}</div>

		</div>
		<div class="inglp">
			<div class="ppo-item lgingi" @click="handleOrder(-1)">{{ $t("other.a839") }}({{ shopInfo.amount }})</div>
			<div class="ppo-item  lgingi" @click="handleOrder(0)">
				<span class="ehng"></span>
				{{ $t("other.a893") }}({{ collect }})
			</div>
			<div class="ppo-item lgingi" @click="handleOrder(1)">
				<span class="lgkjg"></span>
				{{ $t("other.a894") }}({{ uncollect }})
			</div>
			<div class="ppo-item lgingi" @click="handleOrder(3)">
				出库后异常({{ trackingWarning }})
			</div>
			<div class="ppo-item lgingi" @click="downloadPrint(1)">
				{{$t('other.a3419')}}
			</div>
			<div class="ppo-item lgingi" @click="downloadAll()" v-if="fromPath">
				批量下载面单
			</div>
			<div class="ppo-item lgingi" @click="exportAll()">
				批量导出
			</div>
		</div>


		<el-table v-if="listOrder" ref="multipleTable" :data="listOrder" tooltip-effect="dark" border
			style="width: 100%;margin-bottom: 50px;" select-all="checkedall" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="55">
			</el-table-column>

			<el-table-column label="order ID">
				<template slot-scope="scope">

					<div class="orderPPC">
						{{ $t("other.a895") }}:
						<el-tooltip v-show="scope.row.amend" effect="light" :content="$t('processed.Themodified')"
							placement="bottom">
							<i class="iconfont icon-sign"></i>
						</el-tooltip>{{ scope.row.orderId }}
					</div>
					<div class="orderPPC">
						{{ $t("other.a594") }}:{{ scope.row.trackingNo }}
					</div>
					<div class="orderPPC">
						{{ $t("other.a593") }}:{{ scope.row.logistics }}({{ kvjmfh(scope.row.orderPdf) }})
					</div>
					<div class="orderPPC">
						{{ $t("other.a583") }}:{{ scope.row.orderStatus }}
						<span v-if="scope.row.orderStatus == 'CANCELLED' || scope.row.orderStatus == 'canceled'"
							style="margin-left:10px;color:red">订单已取消</span>
					</div>
					<div class="orderPPC" style="color:red;" v-if="scope.row.msgToStore">
						{{ $t("other.a897") }}:{{ scope.row.msgToStore }}
					</div>


				</template>
			</el-table-column>
			<el-table-column label="order Time">
				<template slot-scope="scope">
					<div class="ordersn-box">{{ $t('complaint.orderTime') }}：{{ getTime(scope.row.createTime) }}</div>
					<div v-if="!scope.row.cod" class="ordersn-box">{{ $t('complaint.payTime') }}：{{
						getTime(scope.row.payTime)
					}}</div>
					<div v-if="scope.row.cod" class="ordersn-box">
						{{ $t('complaint.payTime') }}：{{ $t('shippedorder.cash_on_delivery') }}</div>
					<div v-if="scope.row.auditTime" class="ordersn-box">{{ $t("other.a898") }}：{{
						getTime(scope.row.auditTime)
					}}</div>
					<div class="ordersn-box">
						{{ $t('lazada.printTime') }}({{ scope.row.printNum }}{{ $t('processed.once') }})：<span
							v-if="scope.row.printTime">{{ getTime(scope.row.printTime) }}</span>
						<span v-if="scope.row.printTime == null">{{ $t('orderPrint.To_print') }}</span>
					</div>
					<div class="ordersn-box">{{ $t('complaint.warehouseExTime') }}：<span v-if="scope.row.packagedTime">{{
						getTime(scope.row.packagedTime) }}</span>
						<span v-if="scope.row.packagedTime == null">{{ $t('processed.Unscannedoutgoing') }}</span>
					</div>
					<div class="ordersn-box">{{ $t('processed.LanShoutime') }}：
						<span v-if="scope.row.shippedTime" style="display:inline-block;min-width:117px">{{
							getTime(scope.row.shippedTime) }}</span>
						<span v-if="scope.row.shippedTime" class="ehng"></span>
						<span style="display:inline-block;width:117px" v-if="scope.row.shippedTime == null">{{
							$t('processed.NotLanShou') }}</span>
						<span v-if="scope.row.shippedTime == null" class="lgkjg"></span>


					</div>
				</template>
			</el-table-column>
			<el-table-column label="Product(s)" width="250">
				<template slot-scope="scope">
					<span v-for="(item, index) in scope.row.items" :key="index">
						<el-tooltip placement="right">
							<div slot="content">
								<div style="display: flex; color: #FFFFFF;align-items: center;">
									<span style="display: inline-block;width: 80px;height: 80px;margin-right: 20px;">
										<img :src="item.attributeImage ? item.attributeImage : item.image" />
									</span>
									<span>
										<div style="padding:5px 0px;font-size:15px">Name：{{ item.itemName }}</div>
										<div v-if="item.storeItem !== null">
											<div style="padding:5px 0px;font-size:15px">cusCode：{{ item.storeItem.cusCode
											}}（{{ item.storeItem.component ? itemnum : setmeal }}）</div>
											<div style="padding:5px 0px;font-size:15px">P_SKU：{{ item.storeItem.itemSku ?
												item.storeItem.itemSku : description }}</div>
											<div style="margin-top: 5px;font-size:15px"
												v-if="item.storeItem.children !== null && !item.storeItem.component">
												<div v-for="(childre, indexTBB) in item.storeItem.children" :key="indexTBB">
													{{ $t('allorders.theitem') }}({{ childre.cusCode }})：{{ childre.skuName
													}}
													{{ $t('allorders.quantity') }}：{{ childre.rate *
														item.variationQuantityPurchased }}
												</div>
											</div>
											<div style="margin-top: 5px;font-size:15px"
												v-if="item.storeItem.children == null">
												<div>
													W_SKU：{{ item.storeItem.skuName }}
													{{ $t('allorders.quantity') }}：{{ item.variationQuantityPurchased }}
												</div>
											</div>
											<div v-if="item.storeItem.additions !== null"
												style="padding:5px 0px;font-size:15px">
												<div style="margin-top: 5px;font-size:15px;color:red"
													v-for="(gift, giftIndex) in item.storeItem.additions" :key="giftIndex">
													{{ $t('other.a497') }}：{{ gift.skuName }}（{{ gift.cusCode }}）
													{{ $t('other.a567') }}：{{ gift.rate * item.variationQuantityPurchased }}
												</div>

											</div>
										</div>
										<div v-else>{{ $t('allorders.Unboundproduct') }}</div>
									</span>
								</div>
							</div>
							<span class="pic-wrapper">
								<img style="width: 100%;" :src="item.attributeImage ? item.attributeImage : item.image" />
								<span class="pic-wrapper-quantity">{{ item.variationQuantityPurchased }}</span>
							</span>
						</el-tooltip>
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="Buyer" show-overflow-tooltip>
				<template slot-scope="scope">
					<div class="orderPPC">{{ $t('other.a595') }}：{{ scope.row.platform }}</div>
					<div class="orderPPC">{{ $t('other.a465') }}：{{ showName(scope.row.userId) }}</div>
					<div class="orderPPC" v-if="scope.row.address">{{ $t("other.a518") }}：{{ scope.row.address.name }}</div>
					<div class="orderPPC" v-if="scope.row.address">{{ $t("other.a899") }}：{{ scope.row.address.phone }}
					</div>
					<div class="orderPPC" v-if="userInfo.userPos == 'SELLER'">{{ $t("other.a900") }}：{{ scope.row.fee }}
					</div>

				</template>
			</el-table-column>


			<el-table-column prop="address" label="Integral" show-overflow-tooltip>
				<template slot-scope="scope">


					<div v-if="scope.row.platform == 'DXS'"><el-button size="mini" type="primary"
							@click="getFee(scope.row.orderId)">{{ $t('processed.Actualexpressfee') }}</el-button></div>
					<div v-show="userId == 'CPCMY(SZ)'"><el-button size="mini" type="primary"
							@click="getFee(scope.row.orderId)">{{ $t('processed.Actualexpressfee') }}</el-button></div>
					<div v-if="scope.row.platform !== 'DXS'">
						<el-dropdown class="ordersn-box" size="mini">

							<el-button size="mini" style="width:150px;margin:3px 0px" class="ordersn-box" type="primary">{{
								$t("other.a901") }}</el-button>

							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item @click.native="startReadyOrders(scope.row, 0)">
									{{ $t('storePending').drop_off }}
								</el-dropdown-item>
								<el-dropdown-item @click.native="startReadyOrders(scope.row, 1)">
									{{ $t('storePending').pick_up }}
								</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
					<div class="ordersn-box" v-if="scope.row.platform !== 'DXS'"><el-button size="mini"
							style="width:150px;margin:3px 0px" type="primary" @click="reStart(scope.row)">{{
								$t("other.a902") }}</el-button></div>
					<div class="ordersn-box" v-if="scope.row.platform !== 'DXS'"><el-button size="mini"
							style="width:150px;margin:3px 0px" type="primary" @click="rePrinted(scope.row)">{{
								$t("other.a903") }}</el-button></div>
				</template>
			</el-table-column>







		</el-table>

		<div class="Pager">
			<el-pagination style="background-color: #fff;" @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage1" :page-sizes="[15, 20, 30, 50]"
				:page-size="conditionData.offset" layout=" total,sizes, prev, pager, next, jumper" :total="amountListCount">
			</el-pagination>
		</div>
		
		<div class="downloadTips" v-if="downloadShow">
			<i class="el-icon-loading"></i>
			{{ $t('other.a3420') }}
		</div>
	</div>
</template>

<script>
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { mapState, mapActions, mapMutations } from 'vuex'
import utils from '../../../utils/utils.js'
import newOrders from '../../../api/moudles/newOrders'
import processedApi from '../../../api/moudles/processed.js'
import orders from '../../../api/moudles/order'


export default {
	data() {
		return {
			volumeweight: this.$t("processed.volumeweight"),
			weight: this.$t("userStoreItems.weight"),
			Takeofboth: this.$t("processed.Takeofboth"),
			description: this.$t("allorders.description"),
			itemnum: this.$t("allorders.item"),
			setmeal: this.$t("allorders.setmeal"),
			tableList: [],
			currentPage1: 1,
			itemTargetList: [],
			shopInfo: {},
			textarea: '',
			textDesc: '',
			dialogVisible: false,
			tableData: [],
			conditionData: {},
			type: -1,
			trackingWarning:0,
			uncollect: 0,
			collect: 0,
			userPage: JSON.parse(localStorage.getItem('userInfo')).userPage ? JSON.parse(localStorage.getItem('userInfo')).userPage.page4 : false,
			multipleSelection: [],
			loading: null,
			fromPath: null,
			downloadShow:false,
		}
	},
	computed: {
		...mapState({
			userId: state => state.login.userInfo.userId || '',
			vipLevel: state => state.login.userInfo.vipLevel || '',
			userPos: state => state.login.userInfo.userPos,
			userInfo: state => state.login.userInfo,


		}),
		listOrder() {
			let type = this.type
			let list = JSON.parse(JSON.stringify(this.tableList))
			console.log(list,'list_1111')
			console.log(type,'type')
			let list2 = []



			if (type == 0) {
				list2 = this.tableList.filter(p => {
					if (p.shippedTime) {
						return p
					}
				})
			} else if (type == 1) {
				list2 = this.tableList.filter(p => {
					if (!p.shippedTime) {
						return p
					}
				})
			} else if (type == 3) {
				list2 = this.tableList.filter(p => {
					if (p.trackingWarning) {
						return p
					}
				})
			} else if (this.conditionData.orderId) {
				list2 = list.filter(p => {
					if (p.orderId == this.conditionData.orderId) {
						return p
					}
				})
			} else {
				list2 = list
			}
			this.amountListCount = list2.length
			let list3 = list2.splice(this.conditionData.page, this.conditionData.offset)
			console.log('list3', list3)
			return list3

		},


	},
	watch: {

	},
	created() {
		this.hfkf()
		if (this.$route.query.fromPath) {
			this.fromPath = this.$route.query.fromPath;
		}
		console.log(this.$route.query.fromPath)
	},
	methods: {
		exportAll() {
			let arr = []
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			this.multipleSelection.forEach(p => {
				console.log(p)
				let attributeImage = ''
				for (let i = 0; i < p.items.length; i++) {
					attributeImage += (p.items[i].attributeImage ? p.items[i].attributeImage : p.items[i].image) + ' '
				}
				let obj = {
					'订单号码': p.orderId,
					'运单号码': p.trackingNo,
					'配送方式': p.logistics,
					'订单状态': p.orderStatus,
					'下单时间': this.getTime(p.createTime),
					'付款时间': this.getTime(p.payTime),
					'推送时间': this.getTime(p.auditTime),
					'打印时间': this.getTime(p.printTime),
					'出库时间': this.getTime(p.packagedTime),
					'揽收时间': this.getTime(p.shippedTime),
					'图片': attributeImage,
					'平台类型': p.platform,
					'卖家昵称': p.userId,
					'收货人': p.address?p.address.name:'',
					'联系方式': p.address?p.address.phone:'',
				}
				arr.push(obj)
			})
			console.log(arr)
			let list=['订单号码','运单号码','配送方式','订单状态','下单时间','付款时间','推送时间','打印时间','出库时间','揽收时间','图片','平台类型','卖家昵称','收货人','联系方式']
			
			utils.exPortEXml(arr,list,list)
		},
		
		downloadPrint(index,items,FItem) {
			console.log(items,'===items')
			let arr = []
			let num = 0;
			if(this.downloadShow){
				this.$message.warning(this.$t('other.a3420'))
				return
			}
			if(index == 2){
				console.log(FItem)
					let status = items.length>1?true:false
					num = 1;
					for (let j = 0; j < items.length; j++) {
						console.log(items[j])
						if((items[j].pintImage&&items[j].pintImage!='')||items[j].standardPattern){
							let item = items[j]
							let pImg = item.pintImage?item.pintImage:item.standardPattern.standardPatternPrintImagesList[0].imageUrl
							// item.image = item.image.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							// item.pintImage = item.pintImage.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							arr.push({
								orderId:item.orderId,
								orderText:status?item.orderId+'-'+(j+1)+'（Total '+items.length+' Pcs）':item.orderId,
								fileName:(status?item.orderId+'-'+(j+1)+'（Total '+items.length+' Pcs）':item.orderId)+'.'+pImg.substring(pImg.lastIndexOf(".") + 1),
								image:item.attributeImage ? item.attributeImage : item.image,
								pintImage:pImg,
								itemSku:item.itemSku,
								variationSku:FItem.distributeGoods?item.storeItem.children[0].skuName: item.storeItem.skuName,
								pdfImagePath:FItem.orderPdf?FItem.orderPdf.pdf:null,
								variationQuantityPurchased:item.variationQuantityPurchased
							})
						}
					}
			}else if(!this.multipleSelection.length&&index == 1){
				this.$message.warning(this.$t('other.a152'))
				return
			}else if(this.multipleSelection.length&&index == 1){
				console.log(this.multipleSelection)
				let numIndex = 0;
				for (let i = 0; i < this.multipleSelection.length; i++) {
					num += 1;
						let status = this.multipleSelection[i].items.length>1?true:false
					for (let j = 0; j < this.multipleSelection[i].items.length; j++) {
						console.log(this.multipleSelection[i].items[j])
						// numIndex = this.multipleSelection[i].items[j].find(item=>item.pintImage)?numIndex+1:numIndex;
						if((this.multipleSelection[i].items[j].pintImage&&this.multipleSelection[i].items[j].pintImage!='')||this.multipleSelection[i].items[j].standardPattern){
							let item = this.multipleSelection[i].items[j]
							let pImg = item.pintImage?item.pintImage:item.standardPattern.standardPatternPrintImagesList[0].imageUrl
							// console.log(item.pintImage.substring(item.pintImage.lastIndexOf(".") + 1))
							// item.image = item.image.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							// item.pintImage = item.pintImage.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							// pImg = pImg.replace("https://xianggangxxerp.oss-cn-hongkong.aliyuncs.com", "/ddxapi")
							arr.push({
								orderId:item.orderId,
								orderText:status?item.orderId+'-'+(j+1)+'（Total '+this.multipleSelection[i].items.length+' Pcs）':item.orderId,
								fileName:(status?item.orderId+'-'+(j+1)+'（Total '+this.multipleSelection[i].items.length+' Pcs）':item.orderId)+'.'+pImg.substring(pImg.lastIndexOf(".") + 1),
								image:item.attributeImage ? item.attributeImage : item.image,
								pintImage:pImg,
								itemSku:item.itemSku,
								variationSku: this.multipleSelection[i].distributeGoods?item.storeItem.children[0].skuName:item.storeItem.skuName,
								pdfImagePath:this.multipleSelection[i].orderPdf?this.multipleSelection[i].orderPdf.pdf:null,
								variationQuantityPurchased:item.variationQuantityPurchased
							})
						}
					}
				}
			}
			if(arr.length == 0){
				this.$message.warning(this.$t('other.a3421'))
				return
			}
			console.log(arr)
			let arrData = []
			let arrOrderId = []
			for(let i = 0;i<arr.length;i++){
				arrData.push({
					"orderId":arr[i].orderId,
					"orderNo":arr[i].orderText,
					"pintImagePath": arr[i].pintImage, 
					"skuName": arr[i].variationSku, 
					"imagePath": arr[i].image, 
					"pdfImagePath":  arr[i].pdfImagePath,
					"variationQuantityPurchased":arr[i].variationQuantityPurchased
				})
				
				if(arrOrderId.indexOf(arr[i].orderId)==-1){
					arrOrderId.push(arr[i].orderId)
				}
			}
			console.log(arrData)
			console.log(arrOrderId)
			
			this.downloadShow = true;

			orders.batchDownloadPrintDrawings(arrData).then(res=>{
				console.log(res.data,'res.data')
				if(res.code == 200){
					this.addPrintNum(arrOrderId)
					this.downloadShow = false
					this.$message.success('成功！')
					this.$refs.multipleTable.clearSelection();
					const url = res.data.downloadUrl
					const a = document.createElement('a')
					a.href = url
					// a.download = fileName
					document.body.appendChild(a)
					a.click()
					// 释放资源
					document.body.removeChild(a)
					window.URL.revokeObjectURL(url)
					
				}else{
					this.downloadShow = false
					this.$message.error('失败！')
				}
			})
		},
		addPrintNum(list) {
			newOrders
				.addPrintNum(list)
				.then(res => {
					if (res.code === 200) {
						console.log('增加了打印次数！')
					} else {
						console.log('增加了打印次数！', res.msg)
					}
				})

		},
		downloadAll() {
			let arr = []
			if (!this.multipleSelection.length) {
				this.$message.warning(this.$t('other.a716'))
				return
			}
			this.loading = this.$loading({
				lock: true,
				text: '下载中！',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			for (let i = 0; i < this.multipleSelection.length; i++) {
				if (this.multipleSelection[i].orderPdf && this.multipleSelection[i].orderPdf.pdf) {
					arr.push(this.multipleSelection[i].orderPdf.pdf);
				}
			}
			console.log(111)
			let fileName = `${arr.length} ${utils.renderTime(new Date().getTime())}.zip`
			this.downloadPdfAsZip(arr, fileName)
		},
		async downloadPdfAsZip(pdfUrls, zipName) {
			const zip = new JSZip();
			const promises = pdfUrls.map(url =>
				axios.get(url, { responseType: 'blob' }).then(res => {
					const fileName = url.split('/').pop();
					zip.file(fileName, res.data);
				})
			);
			await Promise.all(promises);
			const content = await zip.generateAsync({ type: 'blob' });
			saveAs(content, zipName);
			this.loading.close();
			this.$refs.multipleTable.clearSelection();
			this.$message.success('成功！');
			newOrders
				.addPrintNum(pdfUrls)
				.then(res => {
					if (res.code === 200) {
						console.log('增加了打印次数！')
					} else {
						console.log('增加了打印次数！', res.msg)
					}
				})
		},
		showName(id) {
			let sellers = JSON.parse(localStorage.getItem('userInfo')).sellers
			let ttp = null
			if (this.userInfo.userPos == 'STORE') {
				ttp = sellers.find(item => item.userId == id)
			}

			if (this.userInfo.userPos == 'SELLER') {
				ttp = id
			}

			return ttp ? ttp.userName : id
		},
		startReadyOrders(item, num) {
			console.log('num', num)
			let list = [{
				orderId: item.orderId,
				shopId: item.shopId,
				type: num,
				userId: this.userId
			}]
			console.log('list', list)


			newOrders
				.sartReadyOrders(list)
				.then(res => {
					if (res.code === 200) {
						// 将要轮询的订单号暂存起来
						this.itemTargetList = [item.orderId]
						this.getNewOrdersInfo(this.itemTargetList)

					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		handleSizeChange(val) {
			this.conditionData.offset = Number(`${val}`)
		},
		handleCurrentChange(val) {
			this.conditionData.page = this.conditionData.offset * (Number(`${val}`) - 1)

			console.log('conditionData', this.conditionData)
		},

		//轮询运单号是否生成
		getNewOrdersInfo(list) {
			newOrders
				.getNewOrders(list)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						res.data.forEach(p => {
							if (p.trackingNo) {
								this.itemTargetList = []
							}

						})
						setTimeout(() => {
							if (this.itemTargetList.length) {
								this.getNewOrdersInfo(this.itemTargetList)
							} else {
								this.$message.success(this.$t('other.a904'))

								console.log('failErrorOrder', this.failErrorOrder)
							}

						}, 1000)


					} else {
						this.$message.warning(res.msg)
					}
				})
		},

		handleOrder(num) {
			this.type = Number(num)

		},

		reStart(item) {
			console.log(item)
			newOrders
				.sartReadyOrders([{
					orderId: item.orderId,
					shopId: item.shopId,
					type: 0,
					userId: this.userId
				}]).then(res => {
					if (res.code === 200) {

					} else {
						this.$message.warning(res.msg)
					}
				})
		},



		rePrinted(item) {
			console.log(item)
			if (item.country == 'VN') {
				if (!item.orderPdf || item.trackingNo == '') {
					this.$message.warning(this.$t('other.a905'))
					return
				}
				let arr = [item.orderId]
				localStorage.setItem('unprocessedOrderIds', JSON.stringify(arr))
				let routeData2 = null
				routeData2 = this.$router.resolve({
					name: "vnprintPage",
				})
				window.open(routeData2.href, '_blank')
			} else {
				if (item.orderPdf.pdf) {

					window.open(item.orderPdf.pdf)

					newOrders
						.addPrintNum([item.orderId])
						.then(res => {
							if (res.code === 200) {
								console.log('增加了打印次数！')
							} else {
								console.log('增加了打印次数！', res.msg)
							}
						})


				}
			}



		},


		kvjmfh(id) {

			let ttp = null
			if (id && id.initType == 0) {
				ttp = 'Drop off'
			} else if (id && id.initType == 1) {
				ttp = 'Pick up'
			}
			return ttp
		},

		getFee(id) {
			console.log(id)
			newOrders
				.queryLogisticsOrder({ orderId: id })
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						this.textDesc = this.$t("homeTwo.SubInspection") + id + this.$t("processed.Actualexpressfee")
						this.tableData = [res.data]
						this.dialogVisible = true
					} else {
						this.$message.warning(res.msg)
					}
				})

		},



		showShopName(id) {
			let ccp = null
			if (this.userPos === 'SELLER') {
				ccp = utils.showshopNameByshopId()

				return ccp[id]
			} else if (this.userPos === 'STORE') {
				ccp = utils.showstoreNameBystoreId(id)

				return ccp
			}


		},

		CopyText(id) {
			console.log(id)
			let _input = document.createElement("input");   // 直接构建input
			_input.value = id;  // 设置内容
			document.body.appendChild(_input);    // 添加临时实例
			_input.select();   // 选择实例内容
			document.execCommand("Copy");   // 执行复制
			this.$message.success(this.$t("orderPrint.Copy"))
			document.body.removeChild(_input); // 删除临时实例
		},

		getTime(item) {
			if (!item) {
				return this.$t('shippedorder.pending_upgrade')
			} else {
				return utils.renderTime(item)
			}
		},
		hfkf() {
			let packagedTime = this.$route.query.packageTime
			this.conditionData = JSON.parse(this.$route.query.dataParams)
			this.conditionData.page = 0;
			console.log('conditionData11', this.conditionData)
			this.shopInfo.packagedTime = packagedTime
			this.showLoading()
			processedApi
				.getProcessedOrderBySeller({
					end: utils.CurdateAddoneday(packagedTime),
					logistics: this.conditionData.logistics,
					offset: null,
					orderId: this.conditionData.orderId,
					packageTime: packagedTime,
					page: 0,
					orderIds: this.conditionData.orderIds,
					partnerId: null,
					shopIds: this.conditionData.shopIds,
					start: packagedTime,
					storeIds: this.userInfo.storeIds,
					userId: this.userId,
          trackingWarning: 0
				})
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						let ttp = {
							list: res.data,
						}
						ttp.list.forEach(p => {
							let stores = JSON.parse(localStorage.getItem('userInfo')).stores
							let obj = stores.find(item => item.storeId === p.storeId)
							if (obj.storeAddress == 'CN' && obj.storeType == 1) {
								p.chinessOverSean = true
							} else {
								p.chinessOverSean = false
							}
						})
						this.isShopee = ttp.list[0].platform
						this.tableList = []
						if (this.conditionData.platform) {
							ttp.list.forEach(k => {
								if (k.platform == this.conditionData.platform) {
									this.tableList.push(k)
								}
							})

						} else {
							this.tableList = ttp.list
						}

						this.shopInfo.amount = this.tableList.length
						this.tableList.forEach(p => {
							if (p.shippedTime) {
								this.collect += 1
							} else {
								this.uncollect += 1
							}
							if(p.trackingWarning){
								this.trackingWarning +=1
							}

						})
						console.log('ttp', this.tableList)
					} else {
						this.$message.warning(res.msg)
					}
				})


		},

		handleSelectionChange(val) {
			console.log(val)
			if (val.length === this.listOrder.length) {
				this.chooseAll = true
			} else {
				this.chooseAll = false
			}
			this.multipleSelection = val
			console.log(this.multipleSelection)

		},
	}

}
</script>

<style>
.processedDetail {
	/* flex: 1; */
	width: 100%;
	box-sizing: border-box;
	padding: 0 20px;
	/* margin: 60px 0 0 0px; */
	position: absolute;
}

.processedDetail .lgingi {
	cursor: pointer;
	margin-right: 30px;
	background-color: #409EFF;
	padding: 3px 8px;
	border-radius: 3px;
}

.processedDetail .ehng {
	display: inline-block;
	width: 15px;
	height: 15px;
	border-radius: 2px;
	background-color: aquamarine;
	margin-left: 15px;
}

.processedDetail .lgkjg {
	display: inline-block;
	width: 15px;
	height: 15px;
	border-radius: 2px;
	background-color: red;
}

.processedDetail .order-list-item {
	position: relative;
	padding-bottom: 10px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.processedDetail .order-title {

	border-bottom: 1px #E0E0E0 solid;
}

.processedDetail .order-title-count {
	color: red;
	font-style: inherit;
	margin-left: 10px;
}

.processedDetail .order-query {
	display: flex;
	justify-content: start;
	align-items: center;
	padding: 10px;
	border-bottom: 1px #E0E0E0 solid;
}

.el-tooltip__popper.is-dark {
	background: #000000 !important;
}



.processedDetail .order-query .query {
	position: relative;
	margin-right: 30px;
}

.processedDetail .list-btn {
	padding: 20px 15px;
}

.processedDetail .list-desc {
	margin-left: 15px;
	border-bottom: 1px #eee solid;
}

.processedDetail .list-desc-item {
	font-size: 14px;

	padding-right: 15px;
}

.icon-box {
	width: 22px;
	height: 22px;
	cursor: pointer;
	display: inline-block;
}

.icon-box.svg-box:hover {
	color: tomato;
}

.processedDetail .list-item-status {
	color: red;
}

.processedDetail .didan {
	font-size: 24px;
}

.processedDetail .list-content {
	display: flex;
	justify-content: space-around;
	/* margin: 20px;
	padding: 20px; */
	/* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
}

.processedDetail .order-pic {
	width: 80px;
	height: 80px;
}

img {
	width: 100%;
}

.processedDetail .list-content-left,
.list-content-right {
	display: flex;

}

.processedDetail .list-item-wrapper {
	box-sizing: border-box;
	padding: 15px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.processedDetail .order-selec {
	width: 150px;
	margin: 0 10px;
}

.processedDetail .block-ttp {
	width: 350px !important;
}

.processedDetail .order-desc {
	width: 30%;
}

.processedDetail .order-title-desc {
	margin-bottom: 15px;
}

.stroeVisble .el-input__inner {
	width: 99%;
	height: 130px;
	font-size: 30px
}

.processedDetail .list-price-item,
.shoper-name {
	padding: 2px 0;
}

.processedDetail .list-number,
.list-price {
	margin-left: 40px;
}

.list-price-btn {
	display: flex;
	flex-direction: column;
}

.list-price-btn-item {
	margin-top: 20px;
	margin-left: 0 !important;
	width: 120px;
}

.processedDetail .primary-btn {
	display: inline-block;
	margin: 0 30px;
}

.second-menu-wrapper {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.asb {
	position: relative;
}

.dialog-wrapper {
	display: flex;
	flex-wrap: wrap;
	position: absolute;
	top: 50px;
	left: -600px;
	bottom: 0;
	right: 0;
	width: 600px;
	background-color: #fff;
	margin: 0 auto;
	z-index: 40;
	box-shadow: 0 0 25px #cac6c6;

}

.dialog-wrapper-item {
	display: inline-block;
	width: 100px;
	height: 100px;
	box-sizing: border-box;
	background-color: #fff;
	padding: 5px;
}


.processedDetail .second-menu {
	display: flex;
	justify-content: flex-start;
	position: relative;

}

.processedDetail .menu-right-btn {
	margin-right: 30px;
	color: #606266;
	;
}


.el-icon-loading:before {
	content: "\E6CF";
	font-size: 20px;
}

.notify-boxw {
	width: 330px;
	height: 80px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	position: absolute;
	top: 150px;
	right: 30px;
	border-radius: 8px;
	box-sizing: border-box;
	padding: 10px;
	z-index: 999999;
}

.processedDetail .second-menu-left {

	display: flex;
	;

}

.processedDetail .search-box {
	/* 	width: 100px; */
	/* margin: 0 10px 0px 10px; */
}


.processedDetail .sousuo-box {
	width: 300px;
	margin-right: 20px;
}

.processedDetail .Pager {
	position: fixed;
	bottom: 0;
	left: 202px;
	right: 0;
	height: 40px;
	line-height: 40px;
	background-color: #fff;
	text-align: right;
}

.processedDetail .chekbox {
	width: 30px;
	height: 30px;
}

.processedDetail .Pager {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	height: 40px;
	line-height: 40px;
	background-color: #fff;
	text-align: right;




}

.processedDetail .inglp {
	display: flex;
	margin-bottom: 20px;
}

.processedDetail .orderPPC {
	font-size: 15px;
	margin: 10px 0;
}

.processedDetail .el-pagination {
	display: flex;
	justify-content: flex-end;
	margin: 0 10px 10px 0;
}

.processedDetail .nodata {
	margin-top: 100px;
	text-align: center;
	color: #000;
}

.processedDetail .checkallbox {
	margin: 7px;
	padding-left: 5px;
	color: #606266;
	font-size: 14px;
	cursor: pointer;

}

.processedDetail .checkallbox:hover {
	color: #409EFF;
}

.processedDetail .checkallbox-oop:hover {
	color: #409EFF;
}

.processedDetail .blank {
	color: #606266;
	text-decoration: none;
}

.processedDetail .createOrder {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-top: 10px;
}

.processedDetail .createOrder-item {
	margin: 0 10px;
}

.processedDetail .el-dropdown-link {
	color: #606266 !important;
}

/* 	.loading-box{
		display: inline-block;
		height: 30px;
	} */

.processedDetail .list-desc {
	display: flex;
	align-items: center;
	margin-left: 15px;
	border-bottom: 1px #eee solid;
}

.processedDetail .chekbox {
	width: 30px;
	height: 30px;
	line-height: 30px;
}

.processedDetail .pic-box {
	display: flex;
	margin: 2px;
	width: 80px;
	height: 80px;
}

.processedDetail .return-item {
	display: flex;
	justify-content: space-between;
	box-sizing: border-box;
	padding: 10px;
	font-size: 14px;
}

.processedDetail .return-item-list {
	display: flex;
	align-items: center;

}

.processedDetail .unfold:nth-of-type(n+4) {
	display: none;

}

.processedDetail .pic-box-desc {
	width: 250px;
	margin-left: 20px;
}

.processedDetail .retrun-reasonr {
	margin-left: 30px;
}

.processedDetail .retrun-reasonr-btn {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-right: 20px;
}

.processedDetail .seller {
	margin-right: 10px;
	font-size: 18px;
}

.processedDetail .return-reasonr-desc {
	box-sizing: border-box;
	padding: 3px 0;
}

.processedDetail .seller-item {
	margin-left: 15px;
	font-size: 14px;
}

.processedDetail .seller-ppc {
	color: red;
}

.ppo {
	display: flex;
	flex-wrap: wrap;
	height: 40px;
	padding: 5px 10px;
	margin: 0px -5px;
	-webkit-box-align: center;
	align-items: center;
	background: rgb(61, 70, 77);
	color: rgb(255, 255, 255);
	border-top: 10px solid rgb(255, 255, 255);
	border-bottom: 10px solid rgb(255, 255, 255);
	border-radius: 2px;

}

.ppo-item {
	font-size: 18px;
	color: #fff;
	margin-right: 10px;
}







.ordersn-box {
	font-size: 12px;
}

.pic-wrapper {
	display: inline-block;
	width: 40px;
	height: 40px;
	margin-right: 5px;
	position: relative;
}

.pic-wrapper-quantity {
	position: absolute;
	top: 0;
	right: 0;
	display: inline-block;
	width: 15px;
	height: 15px;
	line-height: 15px;
	background-color: red;
	font-size: 8px;
	color: #fff;
	text-align: center;
}

.IdScaneArea .el-input__inner {
	width: 99%;
	height: 130px;
	font-size: 30px
}

.flagbox {
	display: inline-block;
	width: 56px;
	height: 30px;
}

.flagbox .el-radio {
	display: flex;
	align-items: center;
}

.flagbox .el-radio__label {
	padding-left: 5px !important;
}

.downloadTips {
	position: fixed;
	z-index: 999;
	background: rgba(0, 0, 0, .3);
	top:50px;
	right: 0;
	width: 100px;
	padding: 10px 20px;
	background-color: #f0f0f0;
	box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.5); /* 阴影效果 */
	display: flex;
	justify-content: center;
	align-items: center;
	box-shadow: #000;
	border-radius: 5px;
}
</style>
